import { render, staticRenderFns } from "./ExamData.vue?vue&type=template&id=33c4a4af&scoped=true&"
import script from "./ExamData.vue?vue&type=script&lang=js&"
export * from "./ExamData.vue?vue&type=script&lang=js&"
import style0 from "./ExamData.vue?vue&type=style&index=0&id=33c4a4af&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4a4af",
  null
  
)

export default component.exports